import styled from 'styled-components';

import { Color } from '@dreryk/color-common-api';

import { HexColorBar, Text } from '@dreryk/react-components';

const StyledHexColorBar = styled(HexColorBar)`
   position: absolute;
   left: 0;
   top: 0;
   bottom: 0;
`;

StyledHexColorBar.displayName = 'StyledHexColorBar';

type ReceptionServiceNameCellProps = {
   readonly name: string;
   readonly color: Color | undefined;
};

export const ReceptionServiceNameCell = (props: ReceptionServiceNameCellProps): JSX.Element => {
   return (
      <>
         {props.color ? <StyledHexColorBar testId={'color'} color={props.color.asHexString()} /> : null}
         <Text testId={'name'}>{props.name}</Text>
      </>
   );
};
